module.exports = __webpack_public_path__ + "static/media/IXT.59f9a517.png";